import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import SEO from '../components/SEO';
import CrisisSupport from '../components/CrisisSupport';
import ScrollIndicator from '../components/ScrollIndicator';
import './AssessmentPage.css';

const Clinics = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('revealed');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    const els = document.querySelectorAll('.scroll-reveal');
    els.forEach((el) => observer.observe(el));
    return () => els.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className="page-assessment" data-testid="clinics-page">
      <SEO
        title="Visiting Assessment Clinics | Port Macquarie, Sydney, Melbourne, Gold Coast, Hamilton | Clinical Minds"
        description="Clinical Minds Psychology runs regular visiting assessment clinics in Port Macquarie, Sydney, Melbourne, the Gold Coast and Hamilton VIC, alongside the Coffs Harbour practice and Australia-wide telehealth."
        canonicalUrl="https://www.clinicalminds.net/clinics"
      />
      <ScrollIndicator />

      <section id="main-content" className="interior-hero" data-testid="page-hero">
        <div className="container">
          <span className="section-label">Clinics</span>
          <h1 className="heading-hero">Visiting Clinics</h1>
        </div>
      </section>

      <section className="assess-section scroll-reveal">
        <div className="container assess-narrow">
          <div className="assess-body">
            <p className="body-medium">
              Clinical Minds Psychology is based in Coffs Harbour and serves the NSW Mid North Coast. Because assessment shouldn't depend on your postcode, I also run regular visiting assessment clinics in Port Macquarie, Sydney, Melbourne and the Gold Coast, and in Hamilton in the far west of Victoria, the part of the world I grew up in. Hamilton clinics run roughly every two to three months. I assess young people and adults Australia-wide with telehealth-supported options.
            </p>
            <p className="body-medium" style={{ marginTop: '1rem' }}>
              Clinic dates vary through the year. Contact us and we'll let you know the next clinic near you.
            </p>
          </div>
        </div>
      </section>

      <section className="assess-cta-section" data-testid="clinics-cta">
        <div className="container">
          <div className="assess-cta-card">
            <h2 className="heading-2">Enquire about the next clinic</h2>
            <p className="body-large">Get in touch and we'll let you know when we're next in your area.</p>
            <div className="assess-cta-buttons">
              <Link to="/contact?enquiry=Assessment" className="btn-primary" data-testid="clinics-enquiry-btn">
                Enquire about the next clinic
              </Link>
              <a href="tel:0266002710" className="assess-phone-cta">
                <Phone size={18} /> 02 6600 2710
              </a>
            </div>
          </div>
        </div>
      </section>

      <CrisisSupport />
    </div>
  );
};

export default Clinics;
